import { CreativeState, delMassId } from 'domains/creative/reduser';
import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { AppState } from 'redux/rootReducer';
import { useDispatchApp } from 'redux/rootSelectors';

interface IUseMassHighlightProps {
  xxhashList: string[];
}

type TUseMassHighlightReturn = string[];

type TFUseDelMassIdCreative = () => () => void;

export const useMassHighlight = ({
  xxhashList,
}: IUseMassHighlightProps): TUseMassHighlightReturn => {
  const massId = useSelector<AppState, CreativeState['massId']>(
    ({ creativeReducer }) => creativeReducer.massId,
    shallowEqual,
  );

  return massId.filter((id) => xxhashList.includes(id));
};

  export const useRemoveMassId = (): TFUseDelMassIdCreative => {
    const dispatch = useDispatchApp();
    return useCallback(
      () => () => {
        dispatch(delMassId());
      },
      [dispatch],
    );
  };
